import { render, staticRenderFns } from "./AIChatFloat.vue?vue&type=template&id=deee5aa2&scoped=true&"
import script from "./AIChatFloat.vue?vue&type=script&lang=js&"
export * from "./AIChatFloat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deee5aa2",
  null
  
)

export default component.exports